import React, { useRef } from 'react'
import Navbar from './Navbar'
import Hero from './Hero'
import About from './About'
import Services from './Services'
import WhyChooseUs from './WhyChooseUs '
import GetInTouch from './GetInTouch'
import Footer from './Footer'
import Testimonial from './Testimonial'
import TeamMember from './TeamMember'

const Home = () => {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null);

  return (
    <div>
      <Navbar refs={{
        homeRef,
        aboutRef,
        servicesRef,
        contactRef,
      }} />
      <div ref={homeRef}>
        <Hero />
      </div>
      <div ref={aboutRef}>
        <About />
      </div>
      <div ref={servicesRef}>
        <Services />
      </div>
      <WhyChooseUs />
      <TeamMember />
      <div ref={contactRef}>
        <GetInTouch />
      </div>
      <Testimonial />
      <Footer refs={{
        homeRef,
        aboutRef,
        servicesRef,
        contactRef,
      }} />

      {/* Fixed Request a Quote Button for Mobile */}
      <button
        className="fixed bottom-4 left-1/2 transform -translate-x-1/2 px-5 py-3 bg-orange-500 text-white font-semibold rounded-full shadow-lg z-50 md:hidden"
        onClick={() => contactRef.current?.scrollIntoView({ behavior: 'smooth' })}
      >
        Book Now
      </button>
    </div>
  )
}

export default Home
